/**
 * RecentOrgsForm: edit form for the `recent-orgs` dynamic block.
 *
 * data: { limit? }
 *
 * The block renders a live carousel of the most recently approved
 * organizations. The only configuration is an optional cap on how many to
 * fetch in total (displayed 3 per page). An empty limit stores no `limit`
 * key, letting the block fall back to its default of 9.
 */
import React from 'react';
import PropTypes from 'prop-types';
import { Form } from 'react-bootstrap';

export default function RecentOrgsForm({ data, onChange }) {
    const d = data || {};

    const handleLimit = (raw) => {
        const trimmed = raw.trim();
        if (trimmed === '') {
            const rest = { ...d };
            delete rest.limit;
            onChange(rest);
            return;
        }
        const parsed = Number(trimmed);
        if (Number.isNaN(parsed)) {
            return;
        }
        onChange({ ...d, limit: parsed });
    };

    return (
        <Form.Group controlId="recent-orgs-limit">
            <Form.Label>Maximum organizations to show</Form.Label>
            <Form.Control
                type="number"
                min={1}
                value={d.limit === undefined ? '' : d.limit}
                onChange={(e) => handleLimit(e.target.value)}
                placeholder="Leave blank for the default (9)"
            />
            <Form.Text muted>
                This block renders the most recently approved organizations in
                this ecosystem, sorted by join date. Leave blank to use the
                default of 9 (3 pages of 3).
            </Form.Text>
        </Form.Group>
    );
}

RecentOrgsForm.propTypes = {
    data: PropTypes.object,
    onChange: PropTypes.func.isRequired,
};

RecentOrgsForm.defaultProps = {
    data: {},
};
